import Controller from '@ember/controller';
import { action } from '@ember/object';

import { TourId } from 'webapp/enums/tour';

interface BubbleEntry {
	type: TourId;
	step: number;
	label: string;
}

interface BubbleCategory {
	name: string;
	items: BubbleEntry[];
}

export default class StorybookBubblesController extends Controller {
	get bubbleCategories(): BubbleCategory[] {
		return [
			{
				name: 'Designer',
				items: [
					{ type: TourId.DESIGNER__DRAG_N_DROP, step: 1, label: 'DESIGNER__DRAG_N_DROP' },
					{
						type: TourId.DESIGNER__RESIZE_BLOCK,
						step: 1,
						label: 'DESIGNER__RESIZE_BLOCK',
					},
					{ type: TourId.DESIGNER__MOVE_BLOCK, step: 1, label: 'DESIGNER__MOVE_BLOCK' },
					{
						type: TourId.DESIGNER__SELECT_VISUALIZATION,
						step: 1,
						label: 'DESIGNER__SELECT_VISUALIZATION',
					},
					{
						type: TourId.DESIGNER__SELECT_DIMENSION,
						step: 1,
						label: 'DESIGNER__SELECT_DIMENSION',
					},
					{
						type: TourId.DESIGNER__CHANGE_DATE_RANGE,
						step: 1,
						label: 'DESIGNER__CHANGE_DATE_RANGE',
					},
					{
						type: TourId.DESIGNER__ADD_TO_LOOP,
						step: 1,
						label: 'DESIGNER__ADD_TO_LOOP',
					},
					{
						type: TourId.DESIGNER__ADD_TO_REPORT,
						step: 1,
						label: 'DESIGNER__ADD_TO_REPORT',
					},
					{
						type: TourId.DESIGNER__SHARABLE_LINK,
						step: 1,
						label: 'DESIGNER__SHARABLE_LINK',
					},
					{ type: TourId.DESIGNER__MORE_OPTION, step: 1, label: 'DESIGNER__MORE_OPTION' },
					{
						type: TourId.DESIGNER__BOARD_MORE_MENU,
						step: 1,
						label: 'DESIGNER__BOARD_MORE_MENU (step 1)',
					},
					{
						type: TourId.DESIGNER__BOARD_MORE_MENU,
						step: 2,
						label: 'DESIGNER__BOARD_MORE_MENU (step 2)',
					},
					{
						type: TourId.DESIGNER__BOARD_MORE_MENU,
						step: 3,
						label: 'DESIGNER__BOARD_MORE_MENU (step 3)',
					},
					{
						type: TourId.DESIGNER__BOARD_MORE_MENU,
						step: 4,
						label: 'DESIGNER__BOARD_MORE_MENU (step 4)',
					},
					{
						type: TourId.DESIGNER__BOARD_MORE_MENU,
						step: 5,
						label: 'DESIGNER__BOARD_MORE_MENU (step 5)',
					},
					{
						type: TourId.DESIGNER__BOARD_MORE_MENU,
						step: 6,
						label: 'DESIGNER__BOARD_MORE_MENU (step 6)',
					},
					{
						type: TourId.DESIGNER__BOARD_MORE_MENU,
						step: 7,
						label: 'DESIGNER__BOARD_MORE_MENU (step 7)',
					},
				],
			},
			{
				name: 'Reports — Pageless',
				items: [
					{
						type: TourId.REPORTS__PAGELESS_ADD_BLOCKS,
						step: 1,
						label: 'REPORTS__PAGELESS_ADD_BLOCKS',
					},
					{
						type: TourId.REPORTS__PAGELESS_ADD_COLUMN,
						step: 1,
						label: 'REPORTS__PAGELESS_ADD_COLUMN',
					},
					{
						type: TourId.REPORTS__PAGELESS_CUSTOMIZE,
						step: 1,
						label: 'REPORTS__PAGELESS_CUSTOMIZE',
					},
					{
						type: TourId.REPORTS__PAGELESS_SHARE,
						step: 1,
						label: 'REPORTS__PAGELESS_SHARE',
					},
					{
						type: TourId.REPORTS__PAGELESS_VIEW_SWITCH,
						step: 1,
						label: 'REPORTS__PAGELESS_VIEW_SWITCH',
					},
				],
			},
			{
				name: 'Reports — Slides',
				items: [
					{
						type: TourId.REPORTS__CREATE_NEW_SLIDE,
						step: 1,
						label: 'REPORTS__CREATE_NEW_SLIDE',
					},
					{
						type: TourId.REPORTS__REORDER_SLIDES,
						step: 1,
						label: 'REPORTS__REORDER_SLIDES',
					},
					{ type: TourId.REPORTS__ADD_NOTE, step: 1, label: 'REPORTS__ADD_NOTE' },
					{ type: TourId.REPORTS__PRESENT, step: 1, label: 'REPORTS__PRESENT' },
				],
			},
			{
				name: 'Reports — Other',
				items: [
					{ type: TourId.REPORTS__DOWNLOAD_PDF, step: 1, label: 'REPORTS__DOWNLOAD_PDF' },
					{
						type: TourId.REPORTS__FIRST_PREVIEW,
						step: 1,
						label: 'REPORTS__FIRST_PREVIEW',
					},
					{
						type: TourId.REPORTS__PREVIEW_POPUP_EDIT,
						step: 1,
						label: 'REPORTS__PREVIEW_POPUP_EDIT',
					},
					{
						type: TourId.REPORTS__PREVIEW_POPUP_SHARE,
						step: 1,
						label: 'REPORTS__PREVIEW_POPUP_SHARE',
					},
					{ type: TourId.REPORTS__FAVORITE, step: 1, label: 'REPORTS__FAVORITE' },
					{
						type: TourId.REPORTS__PLAN_PERFORMER,
						step: 1,
						label: 'REPORTS__PLAN_PERFORMER',
					},
				],
			},
			{
				name: 'Reports — Data Stories',
				items: [
					{
						type: TourId.REPORTS__ADD_DATA_STORY,
						step: 1,
						label: 'REPORTS__ADD_DATA_STORY',
					},
					{
						type: TourId.REPORTS__SELECT_DATA_STORY,
						step: 1,
						label: 'REPORTS__SELECT_DATA_STORY',
					},
					{
						type: TourId.REPORTS__CHANGE_DATA_STORY_SETTINGS,
						step: 1,
						label: 'REPORTS__CHANGE_DATA_STORY_SETTINGS',
					},
					{
						type: TourId.REPORTS__ADD_DATA_ELEMENT,
						step: 1,
						label: 'REPORTS__ADD_DATA_ELEMENT',
					},
					{
						type: TourId.REPORTS__SELECT_DATA_ELEMENT,
						step: 1,
						label: 'REPORTS__SELECT_DATA_ELEMENT',
					},
				],
			},
			{
				name: 'Boards',
				items: [
					{ type: TourId.FIRST_BOARD_VIEW, step: 1, label: 'FIRST_BOARD_VIEW' },
					{ type: TourId.FIRST_BOARD_EDIT, step: 1, label: 'FIRST_BOARD_EDIT' },
					{ type: TourId.FIRST_BOARD_SHARE, step: 1, label: 'FIRST_BOARD_SHARE' },
				],
			},
			{
				name: 'Metrics',
				items: [{ type: TourId.METRICS_SOURCES, step: 1, label: 'METRICS_SOURCES' }],
			},
			{
				name: 'Custom Metrics',
				items: [
					{
						type: TourId.CUSTOM_METRICS_POPUP_QB,
						step: 1,
						label: 'CUSTOM_METRICS_POPUP_QB',
					},
					{
						type: TourId.CUSTOM_METRICS_POPUP_SCRIPT,
						step: 1,
						label: 'CUSTOM_METRICS_POPUP_SCRIPT',
					},
					{ type: TourId.QB_SHEETS, step: 1, label: 'QB_SHEETS (step 1)' },
					{ type: TourId.QB_SHEETS, step: 2, label: 'QB_SHEETS (step 2)' },
				],
			},
			{
				name: 'Clients',
				items: [
					{ type: TourId.CLIENT_PERFORMANCE, step: 1, label: 'CLIENT_PERFORMANCE' },
					{ type: TourId.CLIENTS_SETUP, step: 1, label: 'CLIENTS_SETUP' },
				],
			},
			{
				name: 'Onboarding',
				items: [
					{ type: TourId.ONBOARDING_SOURCE, step: 1, label: 'ONBOARDING_SOURCE' },
					{
						type: TourId.ONBOARDING_CONNECT_SOURCE,
						step: 1,
						label: 'ONBOARDING_CONNECT_SOURCE',
					},
				],
			},
			{
				name: 'Guided Onboarding',
				items: [
					{
						type: TourId.GUIDED_ONBOARDING__METRICS,
						step: 1,
						label: 'GUIDED_ONBOARDING__METRICS (step 1)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__METRICS,
						step: 2,
						label: 'GUIDED_ONBOARDING__METRICS (step 2)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__WIZARD,
						step: 1,
						label: 'GUIDED_ONBOARDING__WIZARD (step 1)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__WIZARD,
						step: 2,
						label: 'GUIDED_ONBOARDING__WIZARD (step 2)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__WIZARD,
						step: 3,
						label: 'GUIDED_ONBOARDING__WIZARD (step 3)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__WIZARD,
						step: 4,
						label: 'GUIDED_ONBOARDING__WIZARD (step 4)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__WIZARD,
						step: 5,
						label: 'GUIDED_ONBOARDING__WIZARD (step 5)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__WIZARD,
						step: 6,
						label: 'GUIDED_ONBOARDING__WIZARD (step 6)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__WIZARD,
						step: 7,
						label: 'GUIDED_ONBOARDING__WIZARD (step 7)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__WIZARD,
						step: 8,
						label: 'GUIDED_ONBOARDING__WIZARD (step 8)',
					},
					{
						type: TourId.GUIDED_ONBOARDING__DATA_MANAGER_SELECTED,
						step: 1,
						label: 'GUIDED_ONBOARDING__DATA_MANAGER_SELECTED',
					},
					{
						type: TourId.GUIDED_ONBOARDING__DATA_MANAGER_POPULAR,
						step: 1,
						label: 'GUIDED_ONBOARDING__DATA_MANAGER_POPULAR',
					},
				],
			},
			{
				name: 'Other',
				items: [{ type: TourId.RECENTLY_DELETED, step: 1, label: 'RECENTLY_DELETED' }],
			},
		];
	}

	@action
	dummyAction() {
		// noop — used for interactive elements in bubble previews
	}
}
